import React, { Component } from 'react'
import video from '../../../assets/video/vidanta.mp4'
import './styles.css'
import { connect } from 'react-redux';
import { LanguageActions } from '../../../redux/language';
import spanish from '../../../common/language/spanis';
import english from '../../../common/language/english';

let lang = spanish;



class Video extends Component {

  componentWillReceiveProps(next) {
    // console.log(next);
    if (next.language === 'spanish') {
        lang = spanish;
    }
    else {
        lang = english;
    }
  }



  render() {
    return (
      
          
          <div className="positionVideo">
              <video className="video" src={video} autoPlay={true} width="100%" muted loop/>
              <div className="overlayVideo">  
                <h2 className="videoText">{lang.component01Video.videotextpart1}<span className="porcent">{lang.component01Video.videotextpart2}</span>{lang.component01Video.videotextpart3}</h2>
              </div>
          </div>

    );
  }
}


const mapStateToProps = state => ({
  language: state.LanguageReducer.language,
});

const mapDispatchToProps = dispatch => ({
  // setCurrentLanguage: (language) => {
  //     dispatch(LanguageActions.setLanguage(language));
  // },
});

// make this component available to the app
export default connect(mapStateToProps, mapDispatchToProps)(Video);
